var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',{staticClass:"tab-element sticky action bg-white",class:{ right: _vm.side === 'right', left: _vm.side === 'left', big: _vm.big, tiny: _vm.tiny }},[_c('div',{staticClass:"d-flex align-items-center justify-content-around w-100 h-100"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }